import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from '../../services/http.service';
import { AuthenService } from '../../services/authen.service';
import { HelperService } from '../../services/helper.service';
@Component({
    selector: '',
    templateUrl: './group-hs-cust-detail.html',
})
export class GroupHSCustDetailComponent implements OnInit {
    subs: any = null;
    id: number = 0;
    item: any = null;


    constructor(private http: HttpService, private auth: AuthenService, private route: ActivatedRoute, private helper: HelperService, private router: Router) {
        this.subs = route.params.subscribe(params => {
            this.id = params['id'];
        })
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    ngOnInit() {

        let idGet = (this.id == undefined || this.id == null) ? 0 : this.id;

        this.load(idGet);
    }

    load(id: number) {
        this.http.get(`api/GroupHSCustMatrix/GetById/${id}`, res => {
            this.item = res.Result;
        });
    }

    isInputValid() {
        let msg = null;
        if (this.item.CustomerCode == null) {
            msg = 'Customer code is required'
        }
        if (this.item.HSGroupCode == null) {
            msg = 'HS group is required'
        }

        return msg;
    }

    onSave() {
        let err = this.isInputValid();
        if (err == null) {
            this.http.save('api/GroupHSCustMatrix/Save', this.item, res => {
                this.load(res.LongID);
                this.router.navigate(['/group-hs-cust-detail', res.LongID]);
            });
        } else {
            this.helper.alertFailed(err);
        }
    }

   

}
